import { useAuth } from "@/context/AuthContext";
import { ShieldX, Lock } from "lucide-react";

export default function RestrictedAccess() {
  const { blockedIp } = useAuth();
  return (
    <div className="min-h-screen bg-[hsl(var(--sidebar))] text-white flex items-center justify-center p-6" data-testid="restricted-access">
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "repeating-linear-gradient(-45deg,#fff 0,#fff 1px,transparent 1px,transparent 24px)" }} />
      <div className="relative max-w-md text-center">
        <img src="/monge-logo-footer.svg" alt="Monge & Associates" className="h-8 w-auto mx-auto mb-10" />
        <div className="grid place-items-center h-16 w-16 mx-auto rounded-sm bg-primary/20 text-primary mb-6">
          <ShieldX className="h-8 w-8" />
        </div>
        <h1 className="font-display font-extrabold text-3xl tracking-tight">Access Restricted</h1>
        <p className="text-white/60 mt-3 text-sm leading-relaxed">
          This is a private system. Access is limited to authorized networks and personnel.
        </p>
        {blockedIp && (
          <div className="mt-5 inline-flex items-center gap-2 text-xs bg-white/5 border border-white/10 px-3 py-1.5 rounded-sm font-mono">
            <Lock className="h-3.5 w-3.5 text-primary" /> Your IP: {blockedIp}
          </div>
        )}
      </div>
    </div>
  );
}
